// extracted by mini-css-extract-plugin
export var progressBar = "_nx-0";
export var progressBarInner = "_nx-1";